(() => {
  const ROOT_SELECTOR = '[data-balance-launch]';

  function init(root) {
    const overlay = root.querySelector('[data-trio-overlay]');
    const dialog = root.querySelector('.bl-launch__dialog');
    const itemsHost = root.querySelector('[data-trio-items]');
    const message = root.querySelector('[data-trio-message]');
    const submit = root.querySelector('[data-submit-trio]');
    const picker = root.querySelector('[data-open-custom]');
    const count = root.querySelector('[data-trio-count]');
    const names = root.querySelector('[data-trio-names]');
    const selectedList = root.querySelector('[data-selected-list]');
    const catalog = new Map([...root.querySelectorAll('template[data-balance-product]')].map((node) => [node.dataset.balanceProduct, node]));
    const storageKey = `balance-trio-selection:${root.dataset.sectionId}`;
    const selected = [];
    let previousFocus = null;
    let previousOverflow = '';
    let openItems = [];

    function setMessage(value) { message.textContent = value || ''; }
    try {
      const saved = JSON.parse(sessionStorage.getItem(storageKey) || '[]');
      if (Array.isArray(saved)) selected.push(...saved.filter((handle) => catalog.has(handle)).slice(0, 3));
    } catch (_) {}
    function saveSelection() {
      try { sessionStorage.setItem(storageKey, JSON.stringify(selected)); } catch (_) {}
    }
    function updatePicker() {
      count.textContent = String(selected.length);
      names.textContent = selected.length === 3 ? 'Ready to choose powers' : selected.length ? `Choose ${3 - selected.length} more ${selected.length === 2 ? 'pair' : 'pairs'}` : 'Choose your first pair';
      picker.disabled = selected.length !== 3;
      picker.textContent = selected.length === 3 ? 'Choose powers for 3 pairs' : `Choose ${3 - selected.length} more ${selected.length === 2 ? 'pair' : 'pairs'}`;
      root.querySelectorAll('[data-add-shade]').forEach((button) => {
        const amount = selected.filter((handle) => handle === button.dataset.addShade).length;
        const product = button.closest('.bl-launch__product');
        product?.classList.toggle('bl-launch__product--selected', amount > 0);
        button.disabled = selected.length === 3;
        button.textContent = amount ? `+ Add · ${amount}` : '+ Add';
        button.setAttribute('aria-label', `${amount ? `Add another ${button.dataset.productTitle}; ${amount} already selected` : `Add ${button.dataset.productTitle} to your trio`}`);
      });
      selectedList.replaceChildren();
      selected.forEach((handle, index) => {
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.textContent = `${catalog.get(handle)?.dataset.productTitle || handle} ×`;
        remove.setAttribute('aria-label', `Remove ${catalog.get(handle)?.dataset.productTitle || handle} from slot ${index + 1}`);
        remove.addEventListener('click', () => {selected.splice(index, 1); updatePicker();});
        selectedList.append(remove);
      });
      saveSelection();
    }
    function close() {
      overlay.hidden = true;
      document.documentElement.style.overflow = previousOverflow;
      setMessage('');
      previousFocus?.focus();
    }
    function open(handles, label) {
      if (handles.length !== 3 || handles.some((handle) => !catalog.has(handle))) {
        return;
      }
      if (overlay.hidden) {
        previousFocus = document.activeElement;
        previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
      }
      root.querySelector('[data-trio-label]').textContent = `${label.toUpperCase()} · 3 PAIRS`;
      itemsHost.replaceChildren();
      openItems = handles.map((handle, index) => {
        const template = catalog.get(handle);
        const row = document.createElement('div');
        row.className = 'bl-launch__item';
        row.dataset.productHandle = handle;
        const image = template.content.querySelector('img')?.cloneNode(true);
        if (image) row.append(image);
        const main = document.createElement('div');
        main.className = 'bl-launch__item-main';
        const heading = document.createElement('strong');
        heading.textContent = template.dataset.productTitle;
        const change = document.createElement('button');
        change.type = 'button';
        change.className = 'bl-launch__change';
        change.textContent = 'Change shade';
        const changeSelect = document.createElement('select');
        changeSelect.className = 'bl-launch__change-select';
        changeSelect.setAttribute('aria-label', `Change pair ${index + 1}`);
        changeSelect.hidden = true;
        for (const [availableHandle, availableTemplate] of catalog) {
          const option = new Option(availableTemplate.dataset.productTitle, availableHandle, availableHandle === handle, availableHandle === handle);
          changeSelect.add(option);
        }
        change.addEventListener('click', () => {changeSelect.hidden = !changeSelect.hidden; if (!changeSelect.hidden) changeSelect.focus();});
        changeSelect.addEventListener('change', () => {
          const newHandle = changeSelect.value;
          if (!catalog.has(newHandle)) return;
          const nextHandles = openItems.map((entry) => entry.handle);
          nextHandles[index] = newHandle;
          open(nextHandles, label);
        });
        const options = document.createElement('div');
        options.className = 'bl-launch__item-options';
        for (const labelNode of template.content.querySelectorAll('label')) {
          const clone = labelNode.cloneNode(true);
          const select = clone.querySelector('select');
          select.id = `bl-power-${root.dataset.sectionId}-${index}-${select.dataset.optionIndex}`;
          select.addEventListener('change', () => resolveItem(item));
          options.append(clone);
        }
        const status = document.createElement('p');
        status.className = 'bl-launch__item-status';
        status.setAttribute('role', 'status');
        main.append(heading, change, changeSelect, options, status);
        row.append(main);
        itemsHost.append(row);
        const item = {handle, url: template.dataset.productUrl, row, status, variant: null, sequence: 0};
        return item;
      });
      submit.disabled = true;
      submit.textContent = 'Add 3 Pairs to Bag';
      setMessage('Select all required powers. Unavailable combinations cannot be added.');
      overlay.hidden = false;
      dialog.focus();
    }
    async function resolveItem(item) {
      const selects = [...item.row.querySelectorAll('.bl-launch__item-options select')];
      item.variant = null;
      item.sequence += 1;
      const sequence = item.sequence;
      submit.disabled = true;
      setMessage('Select all required powers. Unavailable combinations cannot be added.');
      if (selects.some((select) => !select.value)) {
        item.status.textContent = '';
        return;
      }
      item.status.textContent = 'Checking availability…';
      try {
        const url = new URL(item.url, location.origin);
        url.searchParams.set('option_values', selects.map((select) => select.value).join(','));
        const response = await fetch(url, {credentials: 'same-origin'});
        if (!response.ok) throw new Error('We could not check this power. Please try again.');
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        const raw = page.querySelector('variant-selects [data-selected-variant]')?.textContent?.trim();
        const variant = raw ? JSON.parse(raw) : null;
        if (sequence !== item.sequence || overlay.hidden || !item.row.isConnected) return;
        if (!variant?.id || variant.available !== true) {
          const productName = item.row.querySelector('.bl-launch__item-main strong')?.textContent?.trim() || 'This shade';
          const selectedPowers = selects.map((select) => select.selectedOptions[0]?.textContent?.trim()).filter(Boolean).join(' / ');
          item.status.textContent = `${productName}${selectedPowers ? ` ${selectedPowers}` : ''} is currently unavailable. Choose another power.`;
          return;
        }
        item.variant = variant;
        item.status.textContent = '';
        submit.disabled = openItems.some((entry) => !entry.variant);
        if (!submit.disabled) setMessage('All three pairs are ready.');
      } catch (error) {
        if (sequence !== item.sequence || overlay.hidden || !item.row.isConnected) return;
        item.status.textContent = error.message || 'Could not check availability.';
      }
    }
    async function addTrio() {
      if (submit.disabled || openItems.length !== 3 || openItems.some((item) => !item.variant)) return;
      submit.disabled = true;
      submit.textContent = 'Adding your trio…';
      setMessage('');
      const grouped = new Map();
      for (const item of openItems) {
        const id = Number(item.variant.id);
        grouped.set(id, (grouped.get(id) || 0) + 1);
      }
      const items = [...grouped].map(([id, quantity]) => ({id, quantity}));
      const shopRoot = window.Shopify?.routes?.root || '/';
      let added = false;
      try {
        const response = await fetch(`${shopRoot}cart/add.js`, {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          credentials: 'same-origin',
          body: JSON.stringify({items})
        });
        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || 'Could not add the trio. Review your powers and try again.');
        }
        added = true;
        // Read the server cart after the write. The cart, not this image or script, owns discounts and totals.
        const cartResponse = await fetch(`${shopRoot}cart.js`, {credentials: 'same-origin', cache: 'no-store'});
        if (!cartResponse.ok) throw new Error('Your bag was updated. Please open your bag to check the result.');
        const cart = await cartResponse.json();
        if (!cart || !Array.isArray(cart.items)) throw new Error('Your bag was updated. Please open your bag to check the result.');
        try { sessionStorage.removeItem(storageKey); } catch (_) {}
        window.location.assign(`${shopRoot}cart`);
      } catch (error) {
        setMessage(`${error.message || 'Could not add your trio.'} Check your bag before trying again.`);
        submit.textContent = 'Add 3 Pairs to Bag';
        submit.disabled = added;
      }
    }

    root.querySelectorAll('[data-open-trio]').forEach((button) => button.addEventListener('click', () => {
      const card = button.closest('.bl-launch__recommendation');
      const title = card?.dataset.trioTitle || 'Suggested trio';
      open([button.getAttribute('data-product-1'), button.getAttribute('data-product-2'), button.getAttribute('data-product-3')], title);
    }));
    root.querySelectorAll('[data-add-shade]').forEach((button) => button.addEventListener('click', () => {
      if (selected.length === 3) return;
      selected.push(button.dataset.addShade);
      updatePicker();
    }));
    picker.addEventListener('click', () => open([...selected], 'Your balance trio'));
    root.querySelectorAll('[data-close-trio]').forEach((button) => button.addEventListener('click', close));
    submit.addEventListener('click', addTrio);
    overlay.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close();
      if (event.key !== 'Tab') return;
      const focusables = [...dialog.querySelectorAll('button:not([disabled]), select:not([disabled])')];
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) {event.preventDefault(); last.focus();}
      if (!event.shiftKey && document.activeElement === last) {event.preventDefault(); first.focus();}
    });
    updatePicker();
  }
  document.querySelectorAll(ROOT_SELECTOR).forEach(init);
})();
